import { render, staticRenderFns } from "./ModalProductInfo.vue?vue&type=template&id=6c03a60f&"
import script from "./ModalProductInfo.vue?vue&type=script&lang=js&"
export * from "./ModalProductInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports